export default function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/pointRadial.js
// module id = 712
// module chunks = 0